const Chevron = ({ isRotated, color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isRotated ? 'scaleX(-1)' : 'scaleX(1)',
        transition: 'transform 0.3s ease',
      }}
    >
      <path
        d="M9 18L14.6854 12.7071C15.1049 12.3166 15.1049 11.6834 14.6854 11.2929L9 6"
        stroke={color || '#fff'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Chevron;
